import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  Form as BTForm,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import axios from "src/config/axios";
import { Form, Formik } from "formik";
import MultiLanguageInputText from "../../../../../../components/Forms/MultiLanguageInputText";
import { FormColorSelect } from "../../../../../../components/UiComponents/ColorSelect";
import FormInputText from "../../../../../../components/Forms/FormInputText";

const EditHolidayDialog = ({ holiday = {}, handleSuccess, toggle }) => {
  function submit(values, { setSubmitting, setErrors }) {
    setSubmitting(true);
    let request;

    if (values.id) {
      request = axios.put(`/api/v1/holidays/${values.id}.json`, {
        holiday: values,
      });
    } else {
      request = axios.post(`/api/v1/holidays.json`, {
        holiday: values,
      });
    }

    request
      .then(function () {
        toggle();
        handleSuccess();
      })
      .catch(function (e) {
        setErrors(e.response.data);
      });
  }

  const formRef = useRef();

  const handleSubmit = () => {
    formRef.current.handleSubmit();
  };

  const [selectedHoliday, setSelectedHoliday] = useState(null);

  useEffect(() => {
    async function getData() {
      const templateResponse = await axios.get("api/v1/holidays/template.json");

      if (holiday.id) {
        const holidayResponse = await axios.get(
          `api/v1/holidays/${holiday.id}`
        );

        setSelectedHoliday({
          ...templateResponse.data,
          ...holidayResponse.data,
        });
      } else {
        setSelectedHoliday(templateResponse.data);
      }
    }

    getData();
  }, []);

  return (
    <Modal show={true} onHide={toggle}>
      <Modal.Header>
        <Modal.Title>{!holiday ? "Erstellen" : "Bearbeiten"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={{
            ...selectedHoliday,
            name: selectedHoliday?.name ?? "",
          }}
          enableReinitialize={true}
          onSubmit={submit}
        >
          {() => (
            <Form autoComplete="false">
              {!selectedHoliday ? (
                <Spinner
                  className={"d-block mx-auto"}
                  animation="border"
                  variant="primary"
                />
              ) : (
                <>
                  <MultiLanguageInputText
                    label="Name"
                    name="name"
                    languages={["de", "it", "en"]}
                  />
                  <FormInputText type={"date"} label="Von" name="from" />
                  <FormInputText type={"date"} label="Bis" name="to" />

                  <FormColorSelect
                    label={"Farbe"}
                    name={"color"}
                    colors={selectedHoliday.configuration.colors}
                  />
                </>
              )}
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          Schließen
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditHolidayDialog;
